// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AuthRecoverPasswordResponse

export type AuthRecoverPasswordApiResponse = {
	email: string;
	success: boolean;
};

export type AuthRecoverPassword = {
	email: string;
	success: boolean;
};

export function hydrateAuthRecoverPassword(data: AuthRecoverPasswordApiResponse): AuthRecoverPassword {
	return { ...data };
}